import Button from '../Button';
import { IJumpBO } from '../types';
import { CSSProperties, useContext } from 'react';
import Context from '../../container';
import './index.scss';
import classNames from 'classnames';
import MainTitle from '../Common/main-title';
import IconAiArrow from '../../components/IconWrapper/arrow-ai';
import { createContactUsModal } from '../ContactUs';

interface IConsultProps {
  isDetail?: boolean;
  config?: {
    title?: string;
    desc?: string;
    jumpBO?: IJumpBO;
    [propName: string]: any;
  };
}

const Consult: React.FC<IConsultProps> = (props) => {
  const { config, isDetail } = props;
  const { title, desc } = config ?? {};
  const { lang } = useContext(Context);
  const detailButtonStyle: CSSProperties = {
    backgroundColor: '#fff',
    color: '#0366DD',
    fontWeight: 600
  };

  return (
    <div className={classNames({ consult: !isDetail }, { 'detail-consult': isDetail })}>
      {isDetail ? null : (
        <div className="content">
          <MainTitle theme="dark" main={title ?? ''} sub={desc} />
        </div>
      )}

      <div className="button">
        <Button type='black' onClick={() => createContactUsModal()} style={{ width: '234px' }}>
          {lang === 'cn' ? '立即咨询' : 'Consult'} <IconAiArrow />
        </Button>
      </div>
    </div>
  );
};

export default Consult;
